import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable, action } from 'mobx'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import Edit from '@components/Icon/Edit'
import Tooltip from '@components/Tooltip'

class ProjectIndicators extends Component {
  static propTypes = {
    projectStore: PropTypes.object,
    segmentStore: PropTypes.object,
    growlStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      editingTarget: false
    })
  }

  calculateExpertsRequired = () => {
    let sum = 0
    this.props.projectStore.project.expertsRequiredToProject.map(expert => {
      sum += expert.numberOfExpert
      return expert
    })

    return sum
  }

  editTarget = () => {
    return (
      <strong>
        <input
          className='project-indicators__interview-target'
          value={this.props.projectStore.project.interviewTarget}
          ref={input => input && input.focus()}
          onChange={e =>
            (this.props.projectStore.project.interviewTarget = e.target.value.replace(
              /[^\d]/g,
              ''
            ))
          }
          onBlur={this.handleEditTargetBlur}
        />
      </strong>
    )
  }

  handleEditTargetBlur = action(e => {
    this.editingTarget = false
    this.saveInterviewTarget(e)
  })

  saveInterviewTarget = () => {
    this.props.projectStore.saveInterviewTarget().then(() => {
      this.editingTarget = false
      this.props.growlStore.addNotification({
        message: 'Interview target for project was updated',
        autoClose: true,
        title: 'Saved',
        type: 'success'
      })
    })
  }

  calcInterviewsRequested = () => {
    let interviewsRequested = 0
    this.props.segmentStore.segments.forEach(
      segment => (interviewsRequested += segment.numberOfExpert)
    )

    return interviewsRequested
  }

  render () {
    const projectInterviewedExperts = get(
      this.props,
      'projectStore.projectInterviewedExperts'
    )
    if (!projectInterviewedExperts) return null

    return (
      <div className='indicators-wrapper story'>
        <span className='label'>Project indicators</span>
        <ul>
          <li>
            Interviews requested
            <div className='actions'>
              <strong>{this.calcInterviewsRequested()}</strong>
            </div>
          </li>
          <Tooltip tooltip='No. of Target Interviews decided Internally'>
            <li>
              Target
              <div className='actions'>
                {this.editingTarget ? (
                  this.editTarget()
                ) : (
                  <strong>
                    <span className='pull-right m-l-md'>
                      {this.props.projectStore.project.interviewTarget}
                    </span>
                    <span onClick={() => (this.editingTarget = true)}>
                      <Edit />
                    </span>
                  </strong>
                )}
              </div>
            </li>
          </Tooltip>
          <li>
            Experts submitted to client
            <div className='actions'>
              <strong>{projectInterviewedExperts.delivered}</strong>
            </div>
          </li>
          <li>
            Experts interviewed
            <div className='actions'>
              <strong>{projectInterviewedExperts.interviewed}</strong>
            </div>
          </li>
        </ul>
      </div>
    )
  }
}

export default inject(
  'growlStore',
  'segmentStore',
  'projectStore'
)(observer(ProjectIndicators))
